export const countItems = (inputString) => {
  const words = inputString.split(",");
  const nonEmptyWords = words.filter((word) => word.trim() !== "");
  return nonEmptyWords.length;
};

export const getFirstItem = (inputString) => {
  const words = inputString.split(",");
  for (const word of words) {
    if (word.trim() !== "") {
      return word;
    }
  }
  return null;
};
